import dayjs from 'dayjs'
import { user_type } from '~/.server/indent/type'
import { constants } from './constants'
import bcrypt from 'bcryptjs';
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import { USER_I_TYPE } from '~/utils/session/session.server';

dayjs.extend(utc)
dayjs.extend(tz)

type truckGroupType = {
  primary_group_id: number
  truck_type_ids: number[]
}
type routeType = {
  sAliasId: string | number
  sourceId: number
  sourceBranchId: number
  sourceName: string
  dAliasId: string | number
  destinationId: number
  destinationBranchId: number
  destinationName: string
}

interface MetaTag {
  charset?: string;
  name?: string;
  content?: string;
  title?: string;
  property?: string;
  [key: string]: string | undefined;
}

const now = dayjs()

const util = {
  today: now.format('DD-MM-YYYY'),
  currentDate: now.format('YYYY-MM-DD HH:mm'),
  FIFTEENTH_DAY: now.add(15, 'days'),
  WEEK: now.subtract(7, 'day').format('DD-MM-YYYY'),
  MONTH: now.subtract(30, 'day').format('DD-MM-YYYY'),
  THREE_MONTH: now.subtract(90, 'day').format('DD-MM-YYYY'),
  isMobileRegex: new RegExp(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
  ),
  DATE_RANGE_FILTER: {
    TODAY: now.format('YYYY-MM-DD'),
    WEEK: now.subtract(7, 'day').format('YYYY-MM-DD'),
    MONTH: now.subtract(30, 'day').format('YYYY-MM-DD'),
    THREE_MONTH: now.subtract(90, 'day').format('YYYY-MM-DD'),
  },
  now: () => dayjs().format('YYYY-MM-DD HH:mm'),
  nowNonFormat: () => dayjs().format(),
  nowNoTiz: new Date().toISOString().slice(0, 19).replace('T', ' '),
  isExpired(expiryAt: string) {
    const expiredAt = dayjs(expiryAt);
    const today = dayjs();
    const hours = today.diff(expiredAt, 'h');
    return hours > 0
  },
  getExpiryMessage(expiryAt: string) {
    const now = new Date().getTime();
    const expiryDate = new Date(expiryAt).getTime();
    const diffMs = expiryDate - now;

    if (diffMs <= 0) {
      return "Expired";
    }

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) {
      return `Exp in ${diffDays}d`;
    } else if (diffHours > 0) {
      return `Exp in ${diffHours}h`;
    } else if (diffMinutes > 0) {
      return `Exp in ${diffMinutes}min`;
    } else {
      return `Exp in 1 min`;
    }
  },
  getSourceIdparam: (search: string) => {
    const splitSearch = search ? search.split('&') : []
    const param = search.includes('source_id') ? splitSearch[0] : ''
    return param
  },
  getDestinationIdparam: (search: string) => {
    const splitSearch = search ? search.split('&') : []
    const param = search.includes('destination_id') ? splitSearch[0] : ''
    return param
  },
  removeSearchParam: (search: string) => {
    const splitSearch = search ? search.split('&') : []
    const param = splitSearch.filter((w) => !w.startsWith('search')).join('&')
    return param
  },
  removeOffsetParam: (search: string) => {
    const splitSearch = search ? search.split('&') : []
    const param = splitSearch.filter((w) => !w.startsWith('offset')).join('&')
    return param
  },
  getNameAndMobile: (name: string | null, mobile: string): string => {
    const modifiedName = name ? `${name} - ${mobile}` : mobile
    return modifiedName
  },
  composeRatesParam: (route: routeType, truckGroup: truckGroupType, offset: number) => {
    return `?s_id=${route.sourceId}&b_id=${route.sourceBranchId}&d_id=${route.destinationId}&db_id=${route.destinationBranchId}&tt_id=${truckGroup.truck_type_ids}&tg_id=${truckGroup.primary_group_id}&offset=${offset}`
  },
  validate_pan_format: (pan_number: string) => {
    const pan = pan_number ? pan_number.replace(/\s/g, '') : ''
    const regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
    return pan.length === 10 ? regpan.test(pan) : false
  },
  validate_mobile: (mobile: string) => {
    const length = mobile ? mobile.replace(/\s/g, '').length : ''
    if (length !== 10) {
      throw new Error(`Invalid Mobile Number ${mobile}`)
    }
  },
  validate_special_characters: (name: string) => {
    const format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/
    const matched_text = format.test(name)
    if (matched_text) {
      throw new Error(`Company name should not contain special characters ${name}`)
    }
  },
  validateUpi: (upiId: string): boolean => {
    const regex = /[a-zA-Z0-9_]{3,}@[a-zA-Z]{2,}/
    return regex.test(upiId)
  },
  callNow: (mobileNo: string, country_code: string | null = '971') => {
    // const regexPattern = /^(\+?91)?(\d{10})$/
    // if (mobileNo && mobileNo.startsWith('0')) {
    //   mobileNo = mobileNo.slice(1)
    // }
    // if (regexPattern.test(mobileNo)) {
    //   const formattedMobileNo = '+91' + mobileNo.replace(/^(\+?91)?(\d{10})$/, '$2')
    window.location.href = 'tel:' + `+${country_code}${mobileNo}`

  },
  // Function to parse cookie string and retrieve the value of a cookie by its name
  getCookie(cookieString: string, name: string) {
    const cookies = cookieString.split(';').map((cookie) => cookie.trim())
    const cookieObj: { [key: string]: unknown } = {} // Define the type of cookieObj
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=')

      if (cookieName === name) {
        try {
          cookieObj[name] = JSON.parse(decodeURIComponent(cookieValue))
        } catch (error) {
          cookieObj[name] = decodeURIComponent(cookieValue)
        }
      }
    }
    return cookieObj[name]
  },
  getLatLng: (location: string) => {
    const splitLocation = location.length > 0 ? location?.split(',') : ''
    const long = parseFloat(splitLocation[0]?.replace('(', ''))
    const lati = parseFloat(splitLocation[1]?.replace(')', ''))
    return [long, lati]
  },
  getCurrentPageName: (pathname: string, defaultPath: string) => {
    const removeFilter = pathname.split('/').filter((p: string) => p !== 'filter')
    const currentPage =
      removeFilter && removeFilter?.length > 0
        ? removeFilter[removeFilter?.length - 1]
        : defaultPath
    return currentPage
  },
  fetchApi: ({
    url,
    session_variables,
    input,
  }: {
    url: string
    session_variables: string
    input: Record<string, string>
  }) =>
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ session_variables, input }),
    }),
  /**
   * 
   * @param input (String)
   * @returns only numbers (0-9)
   * @example 
   * removeSpecialCharactersAndSpaces(inputString)
   * Output: "1234567890"
   */
  removeSpecialCharactersAndSpaces: (input: string) => {
    return input ? input?.replace(/[^\d]/g, '') : ""
  },
  getUserType(user: USER_I_TYPE): user_type | null {
    const { USER_TYPE } = constants;

    if (user?.is_shipper) {
      return USER_TYPE.SHIPPER;
    } else if (user?.is_carrier) {
      return USER_TYPE.CARRIER;
    } else if (user?.is_employee) {
      return USER_TYPE.EMPLOYEE;
    } else {
      return null;
    }
  },
  baseMeta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'viewport-fit=auto, width=device-width,initial-scale=1,maximum-scale=1' },
    { name: 'theme-color', content: '#000000' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-title', content: 'Open FR8' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
  ],
  defaultMeta: [
    { title: "Open FR8" },
    {
      name: "description",
      content: "Truck Transport and Logistics Company in UAE",
    },
  ],
  uniqueMeta: (layout: MetaTag[], page: MetaTag[]) => [...layout, ...page].reduce((acc, tag) => {
    // Identify unique tags by properties
    const isUnique = !acc.some((existing) =>
      (existing.charset && existing.charset === tag.charset) || // Unique by charset
      (existing.name && existing.name === tag.name) ||         // Unique by name
      (existing.title && existing.title === tag.title)         // Unique by title
    );

    // Add unique tag to accumulator
    if (isUnique) {
      acc.push(tag);
    }

    return acc;
  }, [] as MetaTag[]),
  getUserHashedPassword: async (password: string | null | undefined) => {
    let hashedPassword = null;

    if (password) {
      const salt = await bcrypt.genSalt(11);
      hashedPassword = await bcrypt.hash(password, salt);
    }

    return hashedPassword;
  },
  generateRandomId: () => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 3; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },

  checkChanges: (dbIds: number[] = [], uiIds: number[] = []) => {
    // Early return if the arrays are exactly the same
    if (util.arraysEqual(dbIds, uiIds)) {
      return {
        isChanged: false,
        onlyRemoved: false,
        totallyChanged: false,
        onlyAdded: false,
        removedIds: [],
        addedIds: []
      };
    }

    const dbSet = new Set(dbIds);
    const uiSet = new Set(uiIds);

    const removedIds: number[] = dbIds.filter(id => !uiSet.has(id));
    const addedIds = uiIds.filter(id => !dbSet.has(id));

    const onlyRemoved = removedIds.length > 0 && addedIds.length === 0;
    const onlyAdded = addedIds.length > 0 && removedIds?.length === 0;
    const totallyChanged = addedIds.length > 0 && removedIds?.length > 0

    return {
      isChanged: true,
      onlyRemoved,
      onlyAdded,
      totallyChanged,
      removedIds: removedIds || [],
      addedIds
    };
  },
  arraysEqual: (arr1: number[], arr2: number[]) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((id, index) => id === arr2[index]);
  },
  isPageChanging: (state: string) => {
    return ['loading', 'submitting'].includes(state)
  },
  getTime(no_minutes: boolean) {
    const d = new Date();
    const minutes = Math.round(d.getMinutes() / 15) * 15;
    return { hours: d.getHours(), minutes: no_minutes ? 0 : minutes === 60 ? 0 : minutes }
  },
  utcTimeString(date: string) {
    return dayjs.utc(date).format('DD-MM-YYYY HH:mm')
  },
  calculateCarrierPrice(shipper_price: number | null | undefined, mamul: number | null | undefined): number {
    return (shipper_price ?? 0) - (mamul ?? 0);
  },
  convertBase64ToBlob(base64String: string) {
    const base64Data = base64String.split(",")[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    // Create a Blob and a URL from the Blob
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    return url
  },
  getTextAvatar(name: string) {
    // Split the name by spaces to get individual words
    const words = name.trim().split(/\s+/);
    // Map over the words and get the first letter of each word
    const initials = words.slice(0, 2).map(word => word[0].toUpperCase()).join('');
    return initials;
  },
  getView(keyName: string) {
    const view = localStorage.getItem(keyName) ||
      (util.isMobileRegex.test(navigator.userAgent) ? "card" : "table")
    return view
  },
  getCurrentTab(tabConfig: Array<Record<string, string>>, pathname: string, defaultKey: string) {
    const pathSplit = pathname.split("/");
    const endPath = pathSplit[pathSplit?.length - 1];
    const carrierTabKeys = tabConfig.map((tc) => tc.value);
    const currentTab = carrierTabKeys.includes(endPath) ? endPath : defaultKey;
    return currentTab
  },
  sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  findDocumentNameById(id: number) {
    const document_type: Record<string, { id: number; name: string }> = constants.DOCUMENT_TYPE;
    for (const key in document_type) {
      if (document_type[key].id === id) {
        return document_type[key].name;
      }
    }
    return null;
  },
  sumCharges: (...charges: number[]) => charges.reduce((acc: number, curr: number) => acc + +(curr || 0), 0),
  getTAT: (status_at: string | undefined) => {
    if (!status_at) return '-'
    return `${Math.max(0, Math.floor(dayjs().diff(dayjs(status_at), "days", true)))}`
  },
  minutesToHoursDay: (minutes: number) => {
    const h = (minutes / 60);
    const convertHourOrDay =
      h < 24 ? `${Math.ceil(h)}h` : `${Math.floor(h / 24)}d`;
    return convertHourOrDay
  },
  asFloat: (v: string) => v ? parseFloat(v) : 0,
  nullCheck: (v: number | null) => v || 0,
  getRoleNames(role: number) {
    return constants.GET_ROLE_NAME[role as unknown as keyof typeof constants.GET_ROLE_NAME];
  },
  isInCurrentFinancialYear(dateStr: string) {
    const inputDate = new Date(dateStr);
    const today = new Date();

    // Determine financial year start and end
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0 = Jan, 3 = Apr

    // If month >= April (3), start of FY is April 1 of current year
    const fyStartYear = currentMonth >= 3 ? currentYear : currentYear - 1;

    const fyStart = new Date(fyStartYear, 3, 1);      // April 1
    const fyEnd = new Date(fyStartYear + 1, 2, 31);   // March 31

    // Check if inputDate is within range
    return inputDate >= fyStart && inputDate <= fyEnd;
  },

  convertToWords(num: string) {
    const a = [
      '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
      'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen',
      'sixteen', 'seventeen', 'eighteen', 'nineteen'
    ];
    const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    if (isNaN(Number(num))) return 'invalid number';
    if (num.length > 9) return 'overflow';

    const n = ('000000000' + num).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';

    let str = '';
    str += (Number(n[1]) !== 0) ? (a[+n[1]] || (b[+n[1][0]] + ' ' + a[+n[1][1]])) + ' crore ' : '';
    str += (Number(n[2]) !== 0) ? (a[+n[2]] || (b[+n[2][0]] + ' ' + a[+n[2][1]])) + ' lakh ' : '';
    str += (Number(n[3]) !== 0) ? (a[+n[3]] || (b[+n[3][0]] + ' ' + a[+n[3][1]])) + ' thousand ' : '';
    str += (Number(n[4]) !== 0) ? (a[+n[4]] || (b[+n[4][0]] + ' ' + a[+n[4][1]])) + ' hundred ' : '';
    str += (Number(n[5]) !== 0) ? ((str !== '') ? 'and ' : '') + (a[+n[5]] || (b[+n[5][0]] + ' ' + a[+n[5][1]])) + ' ' : '';

    return str.trim();
  },

  convertCurrency(value: string) {
    const amount = parseFloat(value.replace(/,/g, ''));
    if (isNaN(amount)) return 'Invalid amount';

    const [rupees, paise] = amount.toFixed(2).split('.');

    let words = util.convertToWords(rupees) + ' dirhams';
    if (parseInt(paise) > 0) {
      words += ' and ' + util.convertToWords(paise) + ' fils';
    }

    const text = words + ' only';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },
  maskAccountNumber(acc?: string) {
    if (!acc) return "";

    const visibleDigits = 4;
    const last4 = acc.slice(-visibleDigits);
    const maskedPart = "*".repeat(Math.max(acc.length - visibleDigits, 0));

    return maskedPart + last4;
  },
  isSystemBlocked: (config: Array<Record<string, string>>) => {
    const carrier = JSON.parse(
      config.find(i => i.key === "carrier_balance_feature")?.value || "{}"
    )?.disable ?? false;

    const downtime = JSON.parse(
      config.find(i => i.key === "transaction_control")?.value || "{}"
    )?.is_downtime ?? false;

    return {
      carrier_balance_feature: carrier,
      transaction_control: downtime
    };
  },
  extractAccountNumber: (
    iban: string | undefined,
    company: string
  ) => {
    const IBAN_CONFIG: Record<string, { ibanLength: number; accountLength: number }> = {
      uae: { ibanLength: 23, accountLength: 16 },
      ksa: { ibanLength: 24, accountLength: 18 },
      omn: { ibanLength: 23, accountLength: 16 },
    };

    if (!iban) {
      return "";
    }

    const normalizedIban = iban.replace(/\s+/g, "").toUpperCase();
    const config = IBAN_CONFIG[company];

    if (!config || normalizedIban.length !== config.ibanLength) {
      return "";
    }

    return normalizedIban.slice(-config.accountLength);
  },
  nullToUndefined: <T extends Record<string, unknown>>(
    obj: T
  ): { [K in keyof T]: Exclude<T[K], null> } => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        value === null ? undefined : value,
      ])
    ) as { [K in keyof T]: Exclude<T[K], null> };
  }
}

export default util
